import {
  useWSSnackbar,
  WSList,
  WSPage,
  WSPageToolbar
} from "@wingspanhq/fe-component-library";
import React from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import { queriesTransactions } from "@query";
import { Tabs } from "../../components/Tabs";
import { BookkeepingRangeSelect } from "./components/BookkeepingRangeSelect";
import { useBookkeepingDateRange } from "./components/useBookkeepingDateRange";
import { useModalAddTransaction } from "./modals/ModalAddTransaction";
import {
  BookkeepingTabSlug,
  PATH_BOOKKEEPING,
  routeHelpersBookkeepingTab
} from "./paths";
import { RouteBookkeepingDashboard } from "./routes/RouteBookkeepingDashboard";
import { RouteBookkeepingProfitAndLoss } from "./routes/RouteBookkeepingProfitAndLoss";
import { RouteBookkeepingReports } from "./routes/RouteBookkeepingReports";
import { RouteBookkeepingTransactions } from "./routes/RouteBookkeepingTransactions";

export const Bookkeeping: React.FC = () => {
  const { openSnackbar } = useWSSnackbar();
  const modalAddTransaction = useModalAddTransaction();
  const [syncTransactions, syncMeta] =
    queriesTransactions.syncTransactions.useMutation();

  const { range } = useBookkeepingDateRange();

  const pathForTab = (tab: BookkeepingTabSlug) =>
    routeHelpersBookkeepingTab.createLocationObject({ tab }).pathname ?? "";

  const tabParams = { filter: { dateRange: range } };
  const tabs = [
    { label: "Dashboard", path: pathForTab("dashboard"), params: tabParams },
    {
      label: "Profit & Loss",
      path: pathForTab("profit-and-loss"),
      params: tabParams
    },
    {
      label: "Transactions",
      path: pathForTab("transactions"),
      params: tabParams
    },
    { label: "Reports", path: pathForTab("reports"), params: tabParams }
  ];

  return (
    <WSPage>
      <WSPageToolbar
        title="Income & Expenses"
        titleAfter={<BookkeepingRangeSelect />}
        actions={[
          {
            buttonKind: "Primary",
            label: "Add transaction",
            onClick: () => {
              void modalAddTransaction.open({});
            }
          },
          {
            label: "Sync new transactions",
            loading: syncMeta.isLoading,
            onClick: () => {
              syncTransactions(
                {},
                {
                  onSuccess: () => {
                    openSnackbar({
                      icon: { name: "check" },
                      message:
                        "Sync started. New transactions will appear shortly."
                    });
                  }
                }
              );
            }
          }
        ]}
      />
      <WSList gap="2XL">
        <Tabs tabs={tabs} />
        <Switch>
          <Route
            path={pathForTab("dashboard")}
            component={RouteBookkeepingDashboard}
          />
          <Route
            path={pathForTab("profit-and-loss")}
            component={RouteBookkeepingProfitAndLoss}
          />
          <Route
            path={pathForTab("transactions")}
            component={RouteBookkeepingTransactions}
          />
          <Route
            path={pathForTab("reports")}
            component={RouteBookkeepingReports}
          />
          <Redirect from={PATH_BOOKKEEPING} to={pathForTab("dashboard")} />
        </Switch>
      </WSList>
    </WSPage>
  );
};
